/**
 * 規格快照格式化工具
 * 用於訂單／出貨單等顯示 order_items.variant_snapshot（如 { size: "l", color: "red" }）
 * 與 ProductDrawerContent 的維度標籤對照一致，可共用
 */
/** 規格維度 key → 顯示標籤（與商品 Drawer 一致） */
const DIM_LABEL = {
    size: '尺寸',
    color: '顏色',
    capacity: '容量',
    material: '材質',
};
/**
 * 將 variant_snapshot 物件格式化成顯示字串
 * 用於訂單明細、出貨單、會員訂單歷史等
 *
 * @param snapshot 規格快照（如 { size: "l", color: "red" }），可為 null/undefined
 * @param options.dimLabels 自訂維度標籤，未提供時使用內建 DIM_LABEL
 * @returns 格式化字串，例如 "尺寸: l / 顏色: red"；無規格時回傳空字串
 *
 * @example
 * formatVariantSnapshot({ size: 'l', color: 'red' }) // "尺寸: l / 顏色: red"
 * formatVariantSnapshot(null) // ""
 */
export function formatVariantSnapshot(snapshot, options) {
    if (!snapshot || typeof snapshot !== 'object')
        return '';
    const labels = options?.dimLabels ?? DIM_LABEL;
    const entries = Object.entries(snapshot)
        .filter(([, v]) => v != null && String(v).trim() !== '')
        .sort(([a], [b]) => a.localeCompare(b));
    if (entries.length === 0)
        return '';
    return entries.map(([k, v]) => `${labels[k] ?? k}: ${v}`).join(' / ');
}
/**
 * 取得規格顯示字串（訂單確認、出貨單、訂單詳情共用）
 * 可接受已格式化的 variantLabel（購物車）或 variant_snapshot 物件（API）
 *
 * @param variantLabel 已格式化的規格字串（如 CartItem.variantLabel）
 * @param variantSnapshot 規格快照物件（如 order_items.variant_snapshot）
 * @param options.dimLabels 自訂維度標籤（傳給 formatVariantSnapshot）
 * @returns 規格顯示字串；無規格時回傳空字串
 */
export function getVariantDisplayText(variantLabel, variantSnapshot, options) {
    if (variantLabel != null && String(variantLabel).trim() !== '')
        return String(variantLabel).trim();
    if (variantSnapshot != null && typeof variantSnapshot === 'object')
        return formatVariantSnapshot(variantSnapshot, options);
    return '';
}
